import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Coupon.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";

const Coupon = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    useEffect(() => {
        setInProp(true);
        document.title = "優惠券";
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Coupon"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            <YStyled.Label style={{ width: "90%",aspectRatio:"1/1" }}>
                                <YStyled.Col align="center" gap=".4rem">
                                    <img src="./assets/ui/coupon.png" />
                                    <YStyled.Span size={17}>開發中</YStyled.Span>
                                    <YStyled.Span size={17}>敬請期待</YStyled.Span>
                                </YStyled.Col>
                            </YStyled.Label>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Coupon);